import { render, staticRenderFns } from "./InvoiceGenerator.vue?vue&type=template&id=3c4ed70a&"
import script from "./InvoiceGenerator.vue?vue&type=script&lang=js&"
export * from "./InvoiceGenerator.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceGenerator.vue?vue&type=style&index=0&id=3c4ed70a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports